module.exports = __webpack_public_path__ + "img/cloud-raining-03.b0262c9d.svg";